export default {
  created() {
    this.$validator.extend('validateRut', {
      getMessage: () => 'El rut es incorrecto',
      validate: (value) => {
        const valid = this.validateRUT(value);
        return valid;
      },
    });
  },
  methods: {
    formatear(rut, dot = true) {
      const clean = rut.replace(/[^0-9kK]+/g, '').toUpperCase().trim();
      const base = clean.slice(0, -1);
      const check = clean.slice(-1);
      const formattedBase = dot ? base.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') : base.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '');
      return `${formattedBase}-${check}`;
    },
    cleanRut(value) {
      return typeof value === 'string' ? value.replace(/[^0-9kK]+/g, '').toUpperCase() : '';
    },
    validateRUT(valueRut) {
      if (typeof valueRut !== 'string') return false;
      const valueClean = this.cleanRut(valueRut);
      let t = parseInt(valueClean.slice(0, -1), 10);
      let m = 0;
      let s = 1;
      while (t > 0) {
        // eslint-disable-next-line no-plusplus
        s = (s + (t % 10) * (9 - (m++ % 6))) % 11;
        t = Math.floor(t / 10);
      }
      const v = s > 0 ? `${s - 1 }` : 'K';
      return v === valueClean.slice(-1);
    },
    verificatorDigit(T) {
      let M = 0;
      let S = 1;
      // eslint-disable-next-line
      for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
      return S ? S - 1 : 'k';
    },
  }
};
